import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../context/installation';
import { AllTriggersQuery, AllTriggersQueryVariables, Query, Trigger } from '../../../../data-access/gql-types/graphql';
import { ALL_TRIGGERS } from '../../../../data-access/queries/triggers';

export const useTriggers = () => {
  const { selectedInstallationId, skipLavvaFetch } = useInstallationContext();

  const { data, loading } = useQuery<AllTriggersQuery, AllTriggersQueryVariables>(ALL_TRIGGERS, {
    variables: { installationId: selectedInstallationId },
    fetchPolicy: 'cache-and-network',
    skip: skipLavvaFetch,
  });

  const allTriggers = useMemo(() => data?.allTriggers as Trigger[], [data?.allTriggers]);

  return {
    allTriggers: allTriggers || [],
    loading,
  };
};
